// extracted by mini-css-extract-plugin
export default {"logo":"HagertyLogo_logo__4TGsC"};